document.querySelectorAll('.counter-item').forEach(function (element) {
    var target = parseInt(element.querySelector('.counter-number').dataset.target, 10);
    console.log(target);

    // Pre-calculate the width of the target number and apply it to prevent layout shifts
    var counterNumberElement = element.querySelector('.counter-number');
    counterNumberElement.textContent = target.toLocaleString();
    var width = counterNumberElement.offsetWidth;
    counterNumberElement.style.width = width + 'px';

    // Reset the text content to '0' for the animation
    counterNumberElement.textContent = '0';
    var count = 0;
    var interval = target / 100;

    var timer = setInterval(function() {
        count += interval;
        counterNumberElement.textContent = Math.min(Math.floor(count), target).toLocaleString();

        if (count >= target) {
            clearInterval(timer);
            counterNumberElement.textContent = target.toLocaleString();
        }
    }, 10);
});
